// LLM generated - Model Claude Opus 4
import { Fragment } from 'react';
import { Accordion, Box, createStyles, Stack } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';
import { IconChevronDown } from '@tabler/icons-react';

import { Text } from '~/domains/design-system/Text';
import dt from '~/testing';

import { Section, SectionContent, SectionTitle } from './components';

import type { FormattedRule } from '~/domains/contest/domains/services/interfaces/full-contest.interface';

export type ScoringAndRulesSectionProps = {
  rules: FormattedRule[];
  isSidePanel?: boolean;
};

const useStyles = createStyles((theme) => ({
  accordion: {
    backgroundColor: 'transparent',

    '& .mantine-Accordion-control': {
      padding: 0,
    },

    '& .mantine-Accordion-chevron': {
      marginLeft: theme.spacing.xs,
    },

    '& .mantine-Accordion-item': {
      borderBottom: 'none',
    },

    '& .mantine-Accordion-content': {
      padding: 0,
      paddingTop: theme.spacing.lg,
    },
  },
  ruleRow: {
    borderBottom: `1px solid ${theme.colors.gray[1]}`,
    paddingTop: theme.spacing.sm,
    paddingBottom: theme.spacing.sm,

    '&:last-child': {
      borderBottom: 'none',
    },
  },
}));

export function ScoringAndRulesSection({ rules, isSidePanel }: ScoringAndRulesSectionProps) {
  const { classes } = useStyles();
  const { t } = useTranslation('contest');

  if (!rules || rules.length === 0) return null;

  return (
    <Section>
      <Accordion
        className={classes.accordion}
        chevron={<IconChevronDown size={16} />}
        data-test-id={dt.contestDetail.section.scoringAndRules?.title}
      >
        <Accordion.Item value="scoringAndRules">
          <Accordion.Control>
            <SectionTitle isSidePanel={isSidePanel} style={{ marginBottom: 0 }}>
              {t('detail.scoringAndRules.title')}
            </SectionTitle>
          </Accordion.Control>
          <Accordion.Panel>
            <SectionContent isSidePanel={isSidePanel}>
              {rules.map(({ title, description }, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <Fragment key={index}>
                  <Box
                    className={classes.ruleRow}
                    data-test-id={dt.contestDetail.section.scoringAndRules?.row}
                  >
                    <Stack /* eslint-disable-line local-rules/use-theme-tokens */ spacing={4}>
                      {title && (
                        <Text variant="subhead-medium" color="gray2.6">
                          {title}
                        </Text>
                      )}
                      <Text variant="body-medium" color="gray2.4">
                        {description}
                      </Text>
                    </Stack>
                  </Box>
                </Fragment>
              ))}
            </SectionContent>
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </Section>
  );
}
